import { createFileRoute } from "@tanstack/react-router";
import InsuranceForTmsDepressionTreatment from "@/pages/InsuranceForTmsDepressionTreatment";
export const Route = createFileRoute("/insurance-for-tms-depression-treatment")(
  {
    component: RouteComponent,
    head() {
      return {
        meta: [
          {
            title:
              "Insurance For TMS Depression Treatment | Neuro Wellness TMS",
          },
          {
            name: "description",
            content:
              "Does insurance cover TMS and SAINT TMS? Learn about coverage, prior authorization, and free benefits verification for depression treatment in Coral Springs, FL.",
          },
          {
            property: "og:title",
            content:
              "Insurance For TMS Depression Treatment | Neuro Wellness TMS",
          },
          {
            property: "og:description",
            content:
              "Does insurance cover TMS and SAINT TMS? Learn about coverage, prior authorization, and free benefits verification for depression treatment in Coral Springs, FL.",
          },
          {
            property: "og:url",
            content:
              "https://neurowellnesstms.com/insurance-for-tms-depression-treatment",
          },
          {
            property: "og:type",
            content: "website",
          },
          {
            name: "twitter:card",
            content: "summary_large_image",
          },
        ],
        links: [
          {
            rel: "canonical",
            href: "https://neurowellnesstms.com/insurance-for-tms-depression-treatment",
          },
        ],
      };
    },
  },
);
function RouteComponent() {
  return <InsuranceForTmsDepressionTreatment />;
}
